import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroPontoEmbarque from '../../actions/pontoEmbarque/adicionarFiltroPontoEmbarque'
import removerFiltroPontoEmbarque from '../../actions/pontoEmbarque/removerFiltroPontoEmbarque'
import FiltroBuscarPontoEmbarque from './FiltroBuscarPontoEmbarque'
import FiltroChaveValor from '../comum/FiltroChaveValor'
import { FILTRO_PONTO_EMBARQUE_NOME, FILTRO_PONTO_EMBARQUE_CIDADE } from '../../util/filtros'

export class FiltroPontosEmbarque extends Component {
  cidadesComoOpcoes () {
    const vistas = new Set()
    return (this.props.pontosEmbarque || [])
      .filter(p => {
        if (vistas.has(p.cidadeId)) return false
        vistas.add(p.cidadeId)
        return true
      })
      .map(p => ({ chave: p.cidadeId, valor: p.nomeCidade }))
      .sort((a, b) => a.valor.localeCompare(b.valor))
  }

  render () {
    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroBuscarPontoEmbarque
            filtro={FILTRO_PONTO_EMBARQUE_NOME}
            isNome={true}
          />
          <FiltroChaveValor
            filtro={FILTRO_PONTO_EMBARQUE_CIDADE}
            opcoes={this.cidadesComoOpcoes()}
            filtrosAdicionados={this.props.filtrosAdicionadosPontoEmbarque}
            adicionarFiltro={this.props.adicionarFiltroPontoEmbarque}
            removerFiltro={this.props.removerFiltroPontoEmbarque}
            isUnico={true}
          />
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  filtrosAdicionadosPontoEmbarque: state.filtrosAdicionadosPontoEmbarque,
  pontosEmbarque: state.pontosEmbarque
})

const mapDispatchToProps = dispatch => bindActionCreators({
  adicionarFiltroPontoEmbarque,
  removerFiltroPontoEmbarque
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroPontosEmbarque)
